"use client";

import { useEffect, useMemo } from "react";

type Props = {
  files: File[];
  onChange: (files: File[]) => void;
};

export default function LiveaboardPendingPhotoGrid({ files, onChange }: Props) {
  const previewUrls = useMemo(
    () => files.map((f) => URL.createObjectURL(f)),
    [files]
  );

  useEffect(() => {
    return () => {
      for (const url of previewUrls) URL.revokeObjectURL(url);
    };
  }, [previewUrls]);

  if (files.length === 0) return null;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {files.map((file, index) => (
        <div
          key={`${file.name}-${file.size}-${index}`}
          className="relative aspect-[4/3] rounded-lg overflow-hidden border border-neutral-200 bg-neutral-100 group"
        >
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={previewUrls[index]}
            alt={file.name}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-2 py-2">
            <p className="text-[10px] text-white truncate">{file.name}</p>
          </div>
          <button
            type="button"
            onClick={() => onChange(files.filter((_, i) => i !== index))}
            className="absolute top-1.5 right-1.5 rounded-full bg-black/60 text-white text-xs px-2 py-0.5 opacity-0 group-hover:opacity-100 transition hover:bg-rose-600"
          >
            Remove
          </button>
        </div>
      ))}
    </div>
  );
}
